import { formatUnits, parseUnits } from 'ethers/lib/utils';
import { config } from '../../config/config';

const calculateBankruptcyPrice = (
    entryPrice?: string,
    isShort?: boolean,
    leverage?: string,
    decimals: number = config.priceFeedDecimal
): string =>
    formatUnits(
        parseUnits(entryPrice || '1', decimals)
            .mul(
                parseUnits('1', decimals)[isShort ? 'add' : 'sub'](
                    parseUnits('1', decimals)
                        .mul(parseUnits('1', decimals))
                        .div(parseUnits(leverage || '1', decimals))
                )
            )
            .div(parseUnits('1', decimals)),
        decimals
    );

export default calculateBankruptcyPrice;
